import { applySnapshot, getSnapshot, types } from 'mobx-state-tree'
import { fromPromise } from 'mobx-utils'
import { apiV1 } from '../../utils'
import { when } from 'mobx'

// модель маппинга роль ↔️ право
const RolePermissionModel = types.model('RolePermissionModel', {
  id: types.identifierNumber,
  appRoleId: types.number,
  permissionId: types.number,
})

const RolePermissionStore = types
  .model('RolePermissionStore')
  .props({
    _data: types.optional(types.array(RolePermissionModel), []),
    _isPending: types.optional(types.boolean, false),
  })
  .actions(self => {
    const API_URL = '/RolePermission'

    const setRolePermissions = permissions => {
      applySnapshot(self._data, permissions)
    }

    // получить список для роли
    const getRolePermissions = roleId => {
      const request = fromPromise(apiV1.get(`${API_URL}?appRoleId=${roleId}`))

      when(() => {
        request.case({
          fulfilled: response => {
            setRolePermissions(response.data)
            return true
          },
        })
      })

      return request
    }

    // добавить permission для роли
    const addRolePermission = (appRoleId, permissionId) => {
      const request = fromPromise(apiV1.post(API_URL, { appRoleId, permissionId }))
      return request
    }

    // удалить permission по id маппинга
    const deleteRolePermission = id => {
      const request = fromPromise(apiV1.delete(`${API_URL}/${id}`))
      return request
    }

    return {
      setRolePermissions,
      getRolePermissions,
      addRolePermission,
      deleteRolePermission,
    }
  })
  .views(self => ({
    get rolePermissions() {
      return getSnapshot(self._data)
    },
    get isPending() {
      return self._isPending
    },
  }))

export default RolePermissionStore
